import { Paper } from '@mui/material';
import { useParams } from 'react-router-dom';
import { LinearBar } from 'shared/components';
import { useCategory } from 'shared/queries';
import { CategoryPage } from './category-page';

export function CategoryResolver() {
    const { categoryId } = useParams<{ categoryId: string }>();
    const { category, isLoading, isFetching } = useCategory(categoryId);

    if (!category || isLoading) {
        return (
            <Paper>
                <LinearBar loading={isLoading} />;
            </Paper>
        );
    }

    return <CategoryPage category={category} isFetching={isFetching} />;
}
